<template>
  <tr>
    <td>{{ profe.nombre }} {{ profe.apellido }}</td>
    <td>{{ profe.alumnos.length }} </td>
  </tr>
</template>

<script>
// import mentorService from '../services/mentor'
export default {
  name: 'AlumnosTotalesPorProfeListaItem',
  components: {
  },
  props: ['profe'],
  data: function () {
    return {
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style>

</style>
